import React from "react";
import "./index.scss";
import classnames from "classnames";
import { AdaptionSection } from "../../../components/AdaptionSection";

const cls = "HomePageLayout";

export interface IHomePageLayout {
  className?: string;
  anchor?: string;
  title: React.ReactNode;
}

export const HomePageLayout: React.SFC<IHomePageLayout> = props => {
  const { className, title, children, anchor } = props;
  return (
    <div className={classnames(cls, className)}>
      {anchor && <a id={anchor} />}
      <div className={`${cls}-title`}>{title}</div>
      <AdaptionSection>{children}</AdaptionSection>
    </div>
  );
};
